import _ from 'underscore';
import getLevel from './get-level';

export function getGridName(selection, typeId) {
  return `settings_locations_excluded_${typeId}`;
}

export function getGridColumnsMetadata() {
  return {
    Location: 'Criterion/Name',
    CampaignId: 'Campaign/Id',
    CampaignName: 'Campaign/Name',
    CampaignType: 'Campaign/CampaignType',
    AdGroupId: 'AdGroup/Id',
    AdGroupName: 'AdGroup/Name',
    Level: 'LevelOfDetails',
  };
}

export function getGridRoute({
  CampaignId,
  AdGroupId,
}, typeRoute) {
  const level = getLevel({
    CampaignId,
    AdGroupId,
  });

  switch (level) {
    case 'AdGroup':
      return `customer/:customer_id/account/:account_id/campaign/:campaign_id/adgroup/:adgroup_id/edit/locations/${typeRoute}`;
    case 'Campaign':
      return `customer/:customer_id/account/:account_id/campaign/:campaign_id/edit/locations/${typeRoute}`;
    case 'Account':
    default:
      return `customer/:customer_id/account/:account_id/campaign/settings/locations/${typeRoute}`;
  }
}

export function getGridRouteForNewUI({
  getUrlSearch,
  entity,
  selection: {
    CampaignId,
    AdGroupId,
  },
}) {
  const path = 'excluded';
  const level = _.result({
    NegativeCampaignCriterion: 'campaign',
    NegativeAdGroupCriterion: 'adgroup',
  }, entity);
  const search = getUrlSearch({
    campaignId: CampaignId,
    adGroupId: AdGroupId,
  });

  return `${path}/${level}${search}`;
}
